import type { TFunction } from "i18next";
import type { ActivityLogs } from "modules/AppointmentDetails/components/ActivityLog/utils/logs";

export enum ACTIVITY_LOG_TYPE {
  All = 0,
  Appointment,
  Customer,
  Desk,
  Kiosk,
  Keylocker,
  AcsesReceiver,
  CheckEvent,
  WorkOrder,
  _LENGTH_
}

export const getFilterName = (filter: ACTIVITY_LOG_TYPE, t: TFunction) => {
  switch (filter) {
    case ACTIVITY_LOG_TYPE.All:
      return t("v8_all", "All");

    case ACTIVITY_LOG_TYPE.Appointment:
      return t("v8_appointment", "Appointment");

    case ACTIVITY_LOG_TYPE.CheckEvent:
      return t("v8_checklist", "Checklist");

    case ACTIVITY_LOG_TYPE.Customer:
      return t("v8_customer", "Customer");

    case ACTIVITY_LOG_TYPE.Desk:
      return t("v8_desk", "Desk");

    case ACTIVITY_LOG_TYPE.Kiosk:
      return t("v8_kiosk", "Kiosk");

    case ACTIVITY_LOG_TYPE.Keylocker:
    case ACTIVITY_LOG_TYPE.AcsesReceiver:
      return t("v8_keylocker", "Keylocker");

    case ACTIVITY_LOG_TYPE.WorkOrder:
      return t("v8_work_order", "Work order");

    default:
      return "";
  }
};

export const getFilterOptions = (activityLogData: ActivityLogs[], t: TFunction) => {
  const activityTypeFilters = new Set<ACTIVITY_LOG_TYPE>([ACTIVITY_LOG_TYPE.All]);
  for (const activity of activityLogData) {
    if (activityTypeFilters.size === ACTIVITY_LOG_TYPE._LENGTH_) break;

    activityTypeFilters.add(activity.activityType);
  }

  return Array.from(activityTypeFilters).map(filter => ({
    key: filter,
    value: filter,
    text: getFilterName(filter, t)
  }));
};
